import {
  DefaultSpinner,
  DurationViewer,
  Text,
} from '~/common/components/defaultUIComponents';
import { RoutineApi } from '~/common/api/zeiterfassungServerApi/RoutineApi';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { Routine } from '~/common/entities/Routines/RoutineTypes';
import { formatName } from '~/common/utils/employeeUtils';
import { useRoutineContext } from './RoutineContext';
import { Paper } from '~/common/components/Paper';
import { SimpleGrid } from '@chakra-ui/react';
import * as dateFns from 'date-fns';
import React from 'react';

interface RoutineStatisticsProps {
  routine: Routine;
}
export const RoutineStatistics: React.FC<RoutineStatisticsProps> = (props) => {
  const [{ data: employees }] = EmployeeApi.hooks.useEmployeeQuery();
  const routineContext = useRoutineContext();
  const [{ data: stats, isLoading }] =
    RoutineApi.hooks.useRoutineStatisticsQuery(
      props.routine,
      routineContext.startDate
        ? dateFns.parse(routineContext.startDate, 'yyyy-MM-dd', new Date())
        : null,
      routineContext.endDate
        ? dateFns.parse(routineContext.endDate, 'yyyy-MM-dd', new Date())
        : null,
    );
  return (
    <>
      {isLoading && <DefaultSpinner h="unset" />}
      {stats && !isLoading && (
        <SimpleGrid w="full" gap={1} columns={6}>
          {stats?.employees
            ?.map((e) => employees?.find((em) => parseInt(em.id) === e))
            ?.filter((e) => !!e)
            ?.map((employee) => (
              <Paper
                key={employee?.id}
                display="flex"
                justifyContent="space-between"
                px={2}
                py={1}
              >
                <Text>{formatName(employee)}</Text>
                <DurationViewer
                  durationInSeconds={
                    (employee &&
                      stats?.durations?.find(
                        (dur) => dur.employee === parseInt(employee.id),
                      )?.duration) ??
                    0
                  }
                />
              </Paper>
            ))}
        </SimpleGrid>
      )}
    </>
  );
};
